import PropTypes from 'prop-types';
import { Lottie as LottiePiccolo } from '@taxdown/piccolo-web';
import { LottieContainer } from './styles';

const Lottie = ({ className, options }) => (
  <LottieContainer className={className}>
    <LottiePiccolo options={{ ...options }} isClickToPauseDisabled />
  </LottieContainer>
);

Lottie.propTypes = {
  options: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

Lottie.defaultProps = {
  className: null,
};

export default Lottie;
